import { combineReducers } from 'redux';
import userReducer from './user/user.reducer';
import propertiesReducer from './properties/properties.reducer';

export default combineReducers({
    user: userReducer,
    properties: propertiesReducer
})